// extracted by mini-css-extract-plugin
export default {"content":"statusColored_content__+qcQT","color":"statusColored_color__d9HJN","text":"statusColored_text__cCUHX"};